import { HttpRequestStatus } from '../../model/enums/httpRequestStatus';
import { User } from '../../model/user';

export type ApiResponse = Record<string, any>;

export enum AuthenticationActionTypes {
  LOGIN_REQUEST = '@@authentication/LOGIN_REQUEST',
  LOGIN_SUCCESS = '@@authentication/LOGIN_SUCCESS',
  LOGIN_ERROR = '@@authentication/LOGIN_ERROR',
  GET_SESSION_REQUEST = '@@authentication/GET_SESSION_REQUEST',
  GET_SESSION_SUCCESS = '@@authentication/GET_SESSION_SUCCESS',
  GET_SESSION_ERROR = '@@authentication/GET_SESSION_ERROR',
  LOGOUT_REQUEST = '@@authentication/LOGOUT_REQUEST'
}

export interface AuthenticationState {
  readonly loginStatus: HttpRequestStatus;
  readonly getSessionStatus: HttpRequestStatus;
  readonly isAuthenticated: boolean;
  readonly account?: User;
  readonly error?: string;
}
